<template>
  <div>
    <Icon
      v-if="gelenval"
      icon="material-symbols:check-circle"
      color="#28c76f"
      width="25"
      height="25"
    />
  </div>
</template>
  <script>
import { Icon } from "@iconify/vue2";
import { BBadge } from "bootstrap-vue";
export default {
  components: {
    BBadge,
    Icon,
  },
  data() {
    return {
      gelenval: "",
    };
  },
  methods: {
    gelenData() {
      this.gelenval = this.params.data.RENK;
    },
  },
  created() {
    this.gelenData();
  },
};
</script>
  <style lang="scss">
.chip {
  display: inline-block;
  padding: 0 25px;
  height: 25px;
  font-size: 10px;
  line-height: 25px;
  border-radius: 25px;
  background-color: #7367f0;
  color: white;
}
</style>